import Cookie from 'js-cookie'

export const clearStorage = () => {
  localStorage.clear()

  Object.keys(sessionStorage)?.forEach((item) => {
    if (!item.includes('utm')) sessionStorage.removeItem(item)
  })

  Object.keys(Cookie.get())?.forEach((item) => {
    Cookie.remove(item)
  })

  window.location.href = '/login'
}
